import { getEnvVar } from './env';
function getStorageBaseUrl() {
    return getEnvVar('STORAGE_ACCESS_URL', { aliases: ['SUPABASE_URL', 'VITE_SUPABASE_URL'] }) ?? '';
}
export function getMediaUrlByPath(storagePath) {
    if (!storagePath)
        return '';
    if (storagePath.startsWith('http://') || storagePath.startsWith('https://')) {
        return storagePath;
    }
    const baseUrl = getStorageBaseUrl();
    if (!baseUrl)
        return '';
    return `${baseUrl}/storage/v1/object/public/media/${storagePath}`;
}
export function getMediaUrl(folder, entitySlug, filename) {
    if (!folder || !entitySlug || !filename)
        return '';
    if (folder.startsWith('http://') || folder.startsWith('https://')) {
        return folder;
    }
    const storagePath = `${folder}/${entitySlug}/${filename}`;
    const baseUrl = getStorageBaseUrl();
    if (!baseUrl) {
        return '';
    }
    return `${baseUrl}/storage/v1/object/public/media/${storagePath}`;
}
//# sourceMappingURL=media-utils.js.map